module.exports = __webpack_public_path__ + "img/migalhas.b3a37a28.svg";